export const HOT_COUNTRIES_INDICATORS_KEY = 'countries.{key}';
export const EMPTY_COUNTRY_ID = null;
